
import { computed, defineComponent, PropType } from 'vue'

// module components
import TtnTimer from '@/modules/TMSModule/components/TtnTimer/index.vue'
import ButtonDropdown from '@/common/components/UI/ButtonDropdown/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'

export default defineComponent({
    components: { TtnTimer, ButtonDropdown, NewButton },
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    emits: ['wait-list'],
    setup(props, { emit }) {
        const emitWaitList = () => emit('wait-list', { ...props.row })

        const getCheckOrTimesIcon = (isCheck: boolean) => {
            return `fas ${isCheck ? 'fa-check text-green-500' : 'fa-times'}`
        }

        const isDirection = computed(() => {
            return (
                props.column &&
                props.row &&
                props.column.key === 'direction' &&
                props.row.direction &&
                props.row.direction.fromCity &&
                props.row.direction.whereCity
            )
        })

        const isFromCity = computed(() => {
            return (
                props.column &&
                props.row &&
                props.column.key === 'fromCity' &&
                props.row.direction &&
                props.row.direction.fromCity
            )
        })

        const isParent = computed(() => props.row.navigationName)

        return {
            isDirection,
            isParent,
            isFromCity,
            emitWaitList,
            getCheckOrTimesIcon,
        }
    },
})
